import React from 'react';
import styles from './Loader.module.css';

const Loader = () => {
  return (
    <div className={styles.loaderWrapper}>
      
      {/* Background ambient glow */}
      <div className={styles.glow}></div>

      <div className={styles.kitchenScene}>
        
        {/* The Steam rising */}
        <div className={styles.steamContainer}>
          <div className={styles.vapor}></div>
          <div className={styles.vapor}></div>
          <div className={styles.vapor}></div>
          <div className={styles.vapor}></div>
        </div>

        {/* The Pot (Handi style) */}
        <div className={styles.potWrapper}>
          <div className={styles.lid}>
            <div className={styles.handle}></div>
          </div>
          <div className={styles.potBody}>
            <div className={styles.rim}></div>
          </div>
        </div>

        {/* The Fire */}
        <div className={styles.stoveSource}>
          <div className={styles.flameBase}>
            <div className={styles.flame}></div>
            <div className={styles.flame}></div>
            <div className={styles.flame}></div>
            <div className={styles.flame}></div>
          </div>
          <div className={styles.woodOrCoals}></div>
        </div>
      </div>

      <div className={styles.textContainer}>
        <h2 className={styles.loadingText}>તાજું બનાવી રહ્યા છીએ...</h2>
        <p className={styles.subText}>Preparing Fresh Food</p>
      </div>

      <div className={styles.ingredients}>
        <span style={{ animationDelay: '0s' }}>🌶️</span>
        <span style={{ animationDelay: '0.2s' }}>🧄</span>
        <span style={{ animationDelay: '0.4s' }}>🌿</span>
        <span style={{ animationDelay: '0.6s' }}>🧅</span>
      </div>
    </div>
  );
};

export default Loader;